import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { apiRequest } from "../../api/client";
import { useToast } from "../../context/ToastContext";

const emptyPromo = {
  code: "",
  name: "",
  discount_type: "percentage",
  discount_value: "",
  start_date: "",
  end_date: "",
  usage_limit: "",
  minimum_order_amount: 0,
  active: true,
};

function toDateInput(value) {
  if (!value) return "";
  return new Date(value).toISOString().slice(0, 16);
}

export default function AdminPromoForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [form, setForm] = useState(emptyPromo);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;
    apiRequest("/api/promocodes", { tokenType: "admin" })
      .then((response) => {
        const promo = response.data.find((item) => String(item.id) === String(id));
        if (promo) setForm({ ...emptyPromo, ...promo, start_date: toDateInput(promo.start_date), end_date: toDateInput(promo.end_date), usage_limit: promo.usage_limit || "" });
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [id]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    try {
      await apiRequest(id ? `/api/promocodes/${id}` : "/api/promocodes", {
        method: id ? "PUT" : "POST",
        tokenType: "admin",
        body: form,
      });
      toast?.show("Promo code saved.");
      navigate("/admin/promocodes");
    } catch (err) {
      setError(err.message);
    }
  }

  if (loading) return <LoadingSpinner />;

  return (
    <div className="admin-page">
      <div className="admin-page-head"><div><span className="eyebrow">Discounts</span><h1>{id ? "Edit Promo Code" : "Add Promo Code"}</h1></div></div>
      <form className="admin-panel form-card" onSubmit={handleSubmit}>
        <div className="form-grid">
          <label><span>Code</span><input value={form.code} onChange={(event) => setForm({ ...form, code: event.target.value.toUpperCase() })} /></label>
          <label><span>Name</span><input value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} /></label>
        </div>
        <div className="form-grid">
          <label><span>Discount type</span><select value={form.discount_type} onChange={(event) => setForm({ ...form, discount_type: event.target.value })}><option value="percentage">Percentage</option><option value="fixed">Fixed amount</option></select></label>
          <label><span>Discount value</span><input type="number" value={form.discount_value} onChange={(event) => setForm({ ...form, discount_value: event.target.value })} /></label>
        </div>
        <div className="form-grid">
          <label><span>Start date</span><input type="datetime-local" value={form.start_date || ""} onChange={(event) => setForm({ ...form, start_date: event.target.value })} /></label>
          <label><span>End date</span><input type="datetime-local" value={form.end_date || ""} onChange={(event) => setForm({ ...form, end_date: event.target.value })} /></label>
        </div>
        <div className="form-grid">
          <label><span>Usage limit</span><input type="number" value={form.usage_limit} onChange={(event) => setForm({ ...form, usage_limit: event.target.value })} /></label>
          <label><span>Minimum order</span><input type="number" value={form.minimum_order_amount} onChange={(event) => setForm({ ...form, minimum_order_amount: event.target.value })} /></label>
        </div>
        <label className="admin-checkbox"><input type="checkbox" checked={form.active} onChange={(event) => setForm({ ...form, active: event.target.checked })} /> Active</label>
        {error && <p className="form-status error">{error}</p>}
        <Button type="submit">Save Promo Code</Button>
      </form>
    </div>
  );
}
